import {
  HttpExclude,
  RequestExpose,
  Resource,
  ResourceCollection,
} from 'simpli-web-sdk'
import {IFaturamentoResourcesHolder} from '@/interfaces/resource/IFaturamentoResourcesHolder'
import {DashboardCollection} from '@/model/collection/DashboardCollection'
import {NoneResource} from '@/model/NoneResource'
import {Dashboard} from '@/model/resource/Dashboard'

@HttpExclude()
export class DashboardFilterCollection extends DashboardCollection {
  constructor() {
    super()
  }

  resource?: IFaturamentoResourcesHolder
  yearList: ResourceCollection<Resource> | null = null

  @RequestExpose() ano: number | string | null = null

  set anoAsResource(input: Resource | null) {
    this.ano = input?.$tag || null
  }

  get anoAsResource() {
    return this.yearList?.getResource(this.ano) || null
  }

  async yearOptions() {
    const years = (await Dashboard.listAvailableYears()) as string[]

    const yearList = years.map(
      (year: string, index) =>
        ({
          $id: index,
          $tag: `${year}`,
        } as Resource)
    )

    this.yearList = new ResourceCollection(NoneResource, yearList)
    return years
  }
}
